var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(.5)"},[React.createElement("rect",{"width":"49.421","height":"49.421","fill":"#0D0D0D","rx":"1","key":0}),React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M22.808 35v-9.42h-3.17V21.91h3.17v-2.707c0-3.142 1.919-4.853 4.722-4.853 1.342 0 2.496.1 2.832.145v3.283h-1.944c-1.524 0-1.82.725-1.82 1.788v2.344h3.636l-.473 3.671h-3.162V35h-3.791z","key":1})]));
}

FacebookInline.defaultProps = {"width":"50","height":"50"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
